<template>
  <div><slot></slot></div>
</template>

<script lang="ts" setup>
  import { provide, toRefs } from 'vue'
  import type { UploadFichierStateProps } from './UploadFichiers.types'
  import { useUploadFichiers } from './useUploadFichiers'
  import { UPLOAD_FICHIER_INJECT } from './constants.ts'

  const props = defineProps<UploadFichierStateProps>()

  const {
    readonly,
    fichiers,
    naturesFichiersFacultatifs,
    naturesFichiersObligatoires,
    naturesFichiersAjoutFacultatifs,
    nombreFichiersMaximum,
    nombreFichiersMinimum,
    messagesAvertissement,
    idDemande,
    typeDemande,
  } = toRefs(props)

  const state = useUploadFichiers({
    idDemande,
    typeDemande,
    readonly,
    fichiers,
    lovNatureFichiers: props.lovNatureFichiers,
    naturesFichiersObligatoires,
    naturesFichiersFacultatifs,
    naturesFichiersAjoutFacultatifs,
    nombreFichiersMaximum: nombreFichiersMaximum,
    nombreFichiersMinimum: nombreFichiersMinimum,
    messagesAvertissement,
    fichierAdd: props.fichierAdd,
    fichierRemove: props.fichierRemove,
  })

  provide(UPLOAD_FICHIER_INJECT, state)
</script>
